export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: "P站视频是什么？",
    answer: "P站视频是全球领先的在线视频分享平台，汇集了海量的视频内容，涵盖多个分类和主题。用户可以在平台上观看、上传、分享视频，也可以与其他用户互动交流。平台以其丰富的内容库、精准的推荐算法和活跃的社区氛围而闻名。",
  },
  {
    question: "如何在P站视频上搜索到高质量的内容？",
    answer: "搜索高质量内容的关键在于掌握正确的搜索技巧。首先使用精准的关键词进行搜索，然后利用平台的筛选功能按播放量或评分排序。关注热门标签和分类也可以帮助你发现优质内容。此外，浏览创作者的频道主页可以集中观看其所有作品。",
  },
  {
    question: "P站视频支持哪些下载方式？",
    answer: "P站视频提供多种下载方式：电脑端可以使用浏览器扩展或专用下载管理器；手机端iOS和Android都有对应的下载工具和应用；此外还有一些在线下载服务可以直接使用。不同方式在便捷性、下载速度和功能丰富度上各有特点，建议根据个人需求选择。",
  },
  {
    question: "P站视频的内容分类有哪些？",
    answer: "P站视频拥有非常丰富的内容分类体系，包括但不限于：音乐、游戏、教育、科技、美食、旅行、时尚、运动、电影、动漫等。每个主分类下还有更细致的子分类。用户可以通过分类导航快速浏览感兴趣的内容类型。平台还会根据热门趋势不断调整和新增分类。",
  },
  {
    question: "如何成为P站视频的创作者？",
    answer: "成为P站视频创作者非常简单，注册账号后即可开始上传视频。建议先确定自己的内容定位和目标受众，从自己擅长和热爱的领域开始创作。初期不需要昂贵的设备，一部智能手机就能开始。持续产出优质内容，积极与观众互动，逐步建立自己的粉丝基础。",
  },
  {
    question: "P站视频的推荐算法是如何工作的？",
    answer: "P站视频的推荐算法综合考虑了多种因素，包括你的观看历史、搜索记录、点赞评论行为、观看时长和跳过的视频等。算法通过这些数据构建你的兴趣画像，然后为你推荐可能感兴趣的内容。你可以通过积极互动（点赞、评论、订阅）来优化推荐效果。",
  },
  {
    question: "P站视频如何保护用户隐私？",
    answer: "P站视频提供了多层次的隐私保护设置。你可以暂停浏览记录、设置收藏夹为私密、控制个人资料的可见范围。平台还支持内容过滤功能，可以屏蔽或限制特定类型的内容。建议定期检查和更新隐私设置，使用强密码和双因素认证增强账户安全性。",
  },
  {
    question: "P站视频的移动端和电脑端有什么区别？",
    answer: "移动端App针对手机使用场景进行了专门优化，支持手势操作、离线缓存、省流量模式等功能，更适合碎片化时间观看。电脑端则在大屏幕上提供更丰富的浏览体验，功能更加全面。两个平台的数据是同步的，你可以根据场景自由切换使用。",
  },
  {
    question: "P站视频如何发现全球各地的内容？",
    answer: "P站视频是一个全球性平台，你可以通过调整语言和地区设置来获取不同地区的内容推荐。使用不同语言的关键词搜索、关注国际创作者、浏览各地区热门排行榜都是发现全球内容的好方法。自动翻译字幕和AI翻译工具可以帮助你克服语言障碍。",
  },
  {
    question: "P站视频平台是否免费使用？",
    answer: "P站视频提供基本的免费使用功能，包括视频观看、搜索、点赞评论等核心功能。平台主要通过广告来维持运营。部分高级功能可能需要付费，如无广告观看、高清下载等。免费用户也可以享受平台的大部分功能，获得良好的使用体验。",
  },
];